import { typedRequest } from '../utils/httpClientTs';
import {
  DashboardNewsfeed,
  DashboardNotification,
  MyChapter,
  UpdateLoginTimeResponse,
} from '../types/dashboard';

export const getNewsfeeds = async (): Promise<DashboardNewsfeed[]> => {
  return typedRequest<DashboardNewsfeed[]>({
    url: '/dashboard/newsfeeds',
    method: 'GET',
  });
};

export const getNotifications = async (): Promise<DashboardNotification[]> => {
  return typedRequest<DashboardNotification[]>({
    url: '/dashboard/notifications',
    method: 'GET',
  });
};

export const getMyChapter = async (): Promise<MyChapter> => {
  return typedRequest<MyChapter>({
    url: '/dashboard/my-chapter',
    method: 'GET',
  });
};

export const updateLoginTime = async (): Promise<UpdateLoginTimeResponse> => {
  return typedRequest<UpdateLoginTimeResponse>({
    url: '/dashboard/update-login-time',
    method: 'POST',
  });
};
